import React from 'react';
import { List, Avatar, Space } from 'antd';
import { MessageOutlined, LikeOutlined, StarOutlined } from '@ant-design/icons';
import CommnetDuoDot from '../iconComponent/CommnetDuoDot';
import CommentAltEdit from '../iconComponent/CommentAltEdit';
import GrinDuoTone from '../iconComponent/GrinDuoTone';
import { ConvertDateShort } from '../../utils/date';
const PrincipleComment = ({ comments = [], likePost }) => {
  //   const listData = [];
  //   for (let i = 0; i < 23; i++) {
  //     listData.push({
  //       href: 'https://ant.design',
  //       title: `นายจิตมั่น ตั้งใจดี`,
  //       avatar:
  //         'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
  //       description: '16 ธ.ค. 2563   เวลา   17:43 น.',
  //       content: `โปสเตอร์บอยคอต เทรลเลอร์เทคอุปนายกมหาอุปราชา เลิฟซี้ลิสต์สเก็ตช์ ช็อปปิ้งมอนสเตอร์ เพาเวอร์นิวส์ดีพาร์ตเมนต์ แซมบ้าราชบัณฑิตยสถานคอนโด มาร์เก็ตติ้งตู้เซฟเซลส์แมนบร็อค โคลีวีซ่า เสกสรรค์ เซี้ยววอล์คฮ่องเต้ พริตตี้ไตรมาสจูนแลนด์ แฟรี่ไนท์คูลเลอร์ออร์แกนนิรันดร์ อาข่าใช้งานแดนเซอร์เชอร์รี่ ตอกย้ำโรแมนติคเดี้ยง โซน เลดี้ไตรมาสเกรย์วืดสามแยก ยิวดี พาร์ตเมนท์โมเต็ลอิสรชนซีนีเพล็กซ์โอยัวะงี้เกรย์ กาญจนาภิเษกจิตพิสัย เบลอเฟอร์รี่ดีพาร์ต เมนต์ จ๊าบอพาร์ตเมนต์นอมินีมาร์จิน กาญจนาภิเษก โปรเจคท์ กิฟท์เฉิ่มโฮลวีต จตุคามบัสโปรเจคท์วอร์รูมปิโตรเคมี วาทกรรมชีส บัลลาสต์เพรสว้อดก้าคันธาระบุญคุณ ทับซ้อนเยอร์บีรา พิซซ่า เอ๊าะแชมเปี้ยน ฟลุกฟรังก์วิลล์รีไซเคิล กิฟท์เทคเนิร์สเซอรีแรงดูดคลิป บอยคอตต์ซัพพลายเออร์เซ็นเตอร์วโรกาสบอมบ์

  // ฟยอร์ดยากูซ่าสี่แยก เต๊ะไวอากร้าตรวจทานเยลลี่โนติส วอลนัตอมาตยาธิปไตยพันธุวิศวกรรม สวีทอินดอร์เจได ซื่อบื้อบิลเวิร์กช็อปมุมมอง อิออน โปรเจกเตอร์ท็อปบูตโบว์ลิ่งแฟร์ เบลอ ทับซ้อนวีน อัลบัมคอนเฟิร์มแจ็กเก็ต ธุรกรรมฮันนีมูนโรแมนติกยนตรกรรมเพียบแปร้ ท็อปบู๊ทเจ็ต ออดิทอเรียมเนิร์สเซอรีมินท์แซนด์วิชโรแมนติก โคโยตีเคลื่อนย้าย เรซินมาร์เก็ตติ้งวอล์กสโรชา ซิมโฟนี่แอ็คชั่นมาร์จินบอยคอตต์

  // เดี้ยงแบนเนอร์ฟาสต์ฟู้ดป๊อป แฟนตาซีอ่อนด้อยร็อค สถาปัตย์โหลยโท่ย แคชเชียร์ อาข่าหน่อมแน้มโฮลวีตดัมพ์ โปสเตอร์ นิรันดร์สโตนม้านั่ง เห่ยหงวน คาราโอเกะซาบะเคลื่อนย้ายวอร์รูม ออร์แกนิกโอวัลติน โรแมนติกวิทย์เกรย์คอร์ปอเรชั่นพุทธภูมิ โปรโมท เวิร์คแซลมอนโปรเจ็กต์แจ๊ส ฟรุต ครัวซองกาญจน์ ธรรมา

  // พงษ์แรลลี่ ม้ง ไนท์พาร์ตเนอร์คองเกรสบรรพชนสัมนา ธรรมางั้นซิ้ม บอยคอตต์จิ๊กโก๋ตุ๊ก โรลออนแผดเผา เซี้ยวอาร์พีจีฮาลาล ซากุระสไตรค์ปัจเจกชนแรลลี่ สปิริตดีมานด์ทาวน์โอวัลติน มอบตัว พรีเมียร์เฟรชชี่ธัมโมเอนทรานซ์ พาสเจอร์ไรส์ เบญจมบพิตรสไลด์ปอดแหก เจี๊ยวสเตเดียมบาบูนคลับฟรังก์ งี้แคร์ เซ็นเตอร์ทอร์นาโด`,
  //     });
  //   }

  const IconText = ({ icon, text }) => (
    <Space>
      {React.createElement(icon)}
      {text}
    </Space>
  );
  return (
    <List
      itemLayout='vertical'
      size='large'
      pagination={{
        onChange: (page) => {},
        pageSize: 5,
      }}
      dataSource={comments}
      renderItem={(item, index) => (
        <div>
          <div className='comment-content-container'>
            <div style={{ height: 50, width: 40 }}>
              <Avatar
                src={
                  'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png'
                }
              />
            </div>
            <div style={{ flex: 1 }}>
              <div className='comment-content'>
                <label className='name-user'>{item.created_user}</label>
                <label className='text-comment'>{item.message}</label>
              </div>
              <div className='comment-date-container' style={{ marginTop: 5 }}>
                <div className='comment-date-info'>
                  <label className='text-comment-date'>
                    {ConvertDateShort(item.created_date, 'DD MMM YYYY')}
                  </label>

                  <div
                    onClick={() => likePost(item)}
                    style={{ paddingLeft: 10, paddingRight: 10 }}
                  >
                    <div className='d-flex-center'>
                      <GrinDuoTone
                        style={
                          item.is_like
                            ? { color: '#0c4da2' }
                            : { color: '#ababab' }
                        }
                        className='comment-alt-edit-duotone-2'
                      />
                      <div style={{ marginRight: 5 }}>{item.count_like}</div>
                      <div>เห็นด้วย</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    />
  );
};

export default PrincipleComment;
